var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitization02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.424 38.4201C29.303 40.4628 28.7333 42.7753 28.7218 45.1016H24.8884V45.0986C24.8884 40.4268 26.6891 36.0167 29.9589 32.6807L30.2416 32.3922C32.7284 29.8536 34.1315 26.5224 34.2119 22.9804C34.5378 23.2986 34.9844 23.4941 35.4759 23.4941H36.8253C37.2949 23.4941 37.7243 23.3159 38.0453 23.0226C37.9786 26.3412 37.002 29.5161 35.2359 32.2538",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0551 45.0987V45.1016H17.2218V45.0987C17.2218 41.4359 15.8111 37.9793 13.2476 35.363L12.9649 35.0746C9.76886 31.8125 7.97585 27.524 7.89822 22.968C8.22597 23.2939 8.67645 23.4942 9.17472 23.4942H10.5241C10.9888 23.4942 11.4125 23.3198 11.7335 23.0313C11.8264 26.5541 13.2275 29.8661 15.7029 32.3923L15.9855 32.6808C19.2554 36.0167 21.0551 40.4268 21.0551 45.0987Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8884 23.0016V45.1016H21.0551V23.0016C21.379 23.3074 21.8169 23.4942 22.2971 23.4942H23.6464C24.1266 23.4942 24.5645 23.3074 24.8884 23.0016Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9721 3.60596V0.898426",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4826 18.5144H20.4616C19.9439 18.5144 19.5241 18.0947 19.5241 17.5768V8.3768C19.5241 7.85894 19.9439 7.43919 20.4616 7.43919H25.4826C26.0005 7.43919 26.4202 7.85894 26.4202 8.3768V17.5768C26.4202 18.0947 26.0005 18.5144 25.4826 18.5144Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6467 23.4937H22.2974C21.2951 23.4937 20.4825 22.681 20.4825 21.6786V18.5144H25.4617V21.6786C25.4617 22.681 24.6491 23.4937 23.6467 23.4937Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84949 3.60596V0.898426",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3599 18.5144H7.33892C6.82124 18.5144 6.4014 18.0947 6.4014 17.5768V8.3768C6.4014 7.85894 6.82124 7.43919 7.33892 7.43919H12.3599C12.8778 7.43919 13.2975 7.85894 13.2975 8.3768V17.5768C13.2975 18.0947 12.8778 18.5144 12.3599 18.5144Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5241 23.4937H9.17483C8.17244 23.4937 7.3598 22.681 7.3598 21.6786V18.5144H12.3391V21.6786C12.3391 22.681 11.5265 23.4937 10.5241 23.4937Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4617 3.60584H20.4825V7.43921H25.4617V3.60584Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3392 3.60584H7.35983V7.43921H12.3392V3.60584Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6402 3.60584H33.6609V7.43921H38.6402V3.60584Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1505 3.60596V0.898426",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6611 18.5144H33.6401C33.1223 18.5144 32.7025 18.0947 32.7025 17.5768V8.3768C32.7025 7.85894 33.1223 7.43919 33.6401 7.43919H38.6611C39.1788 7.43919 39.5987 7.85894 39.5987 8.3768V17.5768C39.5987 18.0947 39.1788 18.5144 38.6611 18.5144Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8252 23.4937H35.4759C34.4735 23.4937 33.6609 22.681 33.6609 21.6786V18.5144H38.6402V21.6786C38.6402 22.681 37.8275 23.4937 36.8252 23.4937Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitization02);
export default __webpack_public_path__ + "static/media/Digitization02.08394e5ccf2c7e45a86ee0db9806e1c0.svg";
export { ForwardRef as ReactComponent };